module.exports = __webpack_public_path__ + "static/media/am.663e08ac.jpg";